import * as _ from 'lodash';

import { types } from '../actions/systemModal';

const initialState = {
  content: null,
  localModalEnabled: false,
  isClosedOutside: false,
  onDismiss: null,
  blurClassName: 'global-darkSmallBlur',
  onlyOverlay: false,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SYSTEM_MODAL_SHOW:
    case types.LOCAL_MODAL_DISMISS:
    case types.LOCAL_MODAL_SHOW:
      return _.assign({}, state, action.payload);
    case types.SYSTEM_MODAL_DISMISS:
      return _.assign({}, state, { ...initialState });
    default:
      return state;
  }
}

// SELECTORS

export const selectors = {
  isVisible: state => !!state.systemModal.content,
  isClosedOutside: state => state.systemModal.isClosedOutside,
  getContent: state => state.systemModal.content,
  getOnDismiss: state => state.systemModal.onDismiss,
  isLocalModalVisible: state => state.systemModal.localModalEnabled,
  getIsLargeBlurSize: state => state.systemModal.blurSize === 'large',
  getIsOnlyOverlay: state => state.systemModal.onlyOverlay,
  getBlurClassName: state => state.systemModal.blurClassName,
};
